angular.module('ikeweb.map').factory('captureMapTopics', ['validationService',

    function(validation) {

        var validators = validation.validators;

        return {
            MAP: {
                CAPTURES: {
                    LOAD: {
                        name: 'map.captures.load',
                        validation: function(captures) {
                            validation
                                .validate(captures).is(validators.anArray)
                                .throwIfErrors();
                        }
                    }
                }
            }
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/map/map.topics.js
// module id = 592
// module chunks = 0